import { createSlice } from "@reduxjs/toolkit";

const latestRateSlice = createSlice({
    name:"latestRates",
    initialState:{
        rates:null
    },
    reducers:{
        setLastestRateList(state,action){
            state.rates = action?.payload;
        },
    }
})


export const {setLastestRateList} = latestRateSlice.actions
export default latestRateSlice.reducer